import React, { useEffect } from "react";
import { motion } from "framer-motion";
import "../components/Styles/home.css";

import xm1 from "../assets/images/xm1.png";
import xmini from "../assets/images/xmini.png";
import xmidmin from "../assets/images/xmid-min.png";
import xmidminn from "../assets/images/xmid3-min.png";
import mainab from "../assets/images/mainab.png";
import mainac from "../assets/images/mainac.png";
import second from "../assets/images/new1a (1).png";
import third from "../assets/images/new2 (1).png";
import fourth from "../assets/images/new3 (1).png";
import fifth from "../assets/images/fifth.png";
import wifi from "../assets/images/wifi.png";
import pantry from "../assets/images/pantry.png";
import printer from "../assets/images/printer.png";
import lounge from "../assets/images/lounge.png";
import helpdesk from "../assets/images/helpdesk.png";
import prooms from "../assets/images/prooms.png";
import dollor from "../assets/images/dollor.png";
import tea from "../assets/images/tea.png";
import msrooms from "../assets/images/mrooms.png";
import framee from "../assets/images/frame (1).png";
import sv1 from "../assets/images/sv1.png";
import sv2 from "../assets/images/sv2.png";
import AOS from "aos";
import "aos/dist/aos.css";
import Slide from "./Slide";

const Home = () => {
  useEffect(() => {
    AOS.init();
  }, []); // ✅ FIX: add dependency array so it doesn't run every render

  return (
    <div>
      <section className="main">
        <div className="main_sec">
          <h1>
            <span style={{ color: "#EEBD2B" }}>Houston’s Executive</span>
            <br /> 
             Workspace for Serious Business

          </h1>

          <p>
Position your company inside a Class A environment designed for professionals who value  credibility, privacy, and performance. Xceed Office delivers private offices, virtual presence  solutions, and conference facilities built to elevate your business image.          </p>

          <button>
      Schedule a Private Tour    </button>{" "}
          <button style={{ background: "#0D0D0D", color: "#EEBD2B", opacity: 1 }}>
            View Office Options
          </button>
        </div>
      </section>

      <br />
      <br />
      <br />

      <section>
        <div className="main_section">
          <h2>Our Workspace Solutions</h2>
          <p>Choose the perfect workspace that fits your needs</p>

          <div className="row_main_section">
            <div className="row_main_col">
              <img src={second} alt="Office Space" />
              <h3>Private Offices</h3>
              <p>Fully furnished executive suites in a Class A setting. Ideal for law firms, consultants, agencies,  and professional teams who require privacy and presence.</p>
            </div>

            <div className="row_main_col">
              <img src={third} alt="Dedicated Desk" />
              <h3>Virtual Office</h3>
              <p>Establish your business in a prestigious Houston address with mail handling, professional  phone answering, and optional meeting access.</p>
            </div>

            <div className="row_main_col">
              <img src={fourth} alt="Meeting Room" />
              <h3>Conference & Day Offices</h3>
              <p>Book fully equipped meeting rooms and private day offices for client presentations, interviews,  and strategic sessions.</p>
            </div>
          </div>
        </div>
      </section>

      <br />
      <br />
      <br />

      <section style={{ background: "#0D0D0D", padding: "3%" }}>
        <div className="main_section">
          <div className="row__4">
            <div className="col__4">
                <p id="tt">Designed for Focus. Built for Growth.</p>
   <p>
Walk your clients into a refined Class A building. Work in a quiet, professional environment that  supports deep focus and strategic thinking. Every detail — from reception to meeting rooms —  is designed to reflect credibility and confidence. 
<br /><br />
Xceed Office is not a shared desk space. It’s a business environment structured for  professionals who take their work seriously.              </p>

            </div>

            <div className="col__4">
              <img src={fifth} alt="Coworking space" />
            </div>
          </div>
        </div>
      </section>

      <br />

      <section style={{ display: "none" }} className="main_sec2">
        <div className="x_row1">
          <div className="x_col">
            <h2 data-aos="fade-right">How does it feel to cowork at The Xceed?</h2>
            <p data-aos="fade-right">
              Surround yourself in a natural environment that resembles to the
              farmlands of the midwest. Lay your laptop on a century old
              reclaimed wood table in one of the oldest historic Soho lofts to
              date and focus on your work via using a solid fast Wi-Fi. Being
              located at a newly renovated loft in Soho you might catch yourself
              imagining the history of NYC by viewing the natural brick wall
              which was laid in the turn of the century. Being surrounded in the
              lofts original brick walls, left bare, will certainly bring
              inspiration to your work.
              <br />
              <br />
              While you are in thirst for coffee you might encounter an amazing
              conversation with a fellow tech founder giving you an advise in
              that fundraising issue you have been facing. Just before leaving
              for the day you might bump in to an event happening where everyone
              is gathered to celebrate the successful work day they have just
              finished. Makes you wonder how in the earth did you tolerate
              working in those loud and lonely coffee shops, trying to compete
              with the espresso machines sound during your important Zoom call.
              Our fully furnished loft designed with organic rustic Americana
              style in mind, will certainly will make you fall in love with work
              again.
            </p>
          </div>

          <div className="x_col">
            <img data-aos="fade-left" id="cpicx" src={xmidmin} alt="Workspace" />
          </div>
        </div>

        <br />
        <br />
      </section>

      <section className="main_sec3">
        <div>
          <div className="col_mlst">
            <h2>
              Why Choose <span style={{ color: "#EEBD2B" }}>Xceed Office?</span>
            </h2>
            <p style={{color:"white"}}>
Executive-level amenities designed to support your business.            </p>
          </div>

          <br />

          <div className="row__sec__4">
            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={wifi} alt="High-speed WiFi" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>High-Speed Wifi</h3>
                  <p>
Enterprise-grade connectivity built for video calls, cloud systems, and uninterrupted productivity.                  </p>
                </div>
              </div>
            </div>

            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={pantry} alt="Pantry" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Virtual Office Services</h3>
                  <p>
 Prestigious business address, mail handling, and phone answering.
                  </p>
                </div>
              </div>
            </div>

            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={printer} alt="Printer" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Business Support Services</h3>
                  <p>
Optional accounting, marketing, and administrative support to streamline operations.                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row__sec__4">
            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={lounge} alt="Lounge" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Meeting & Conference Rooms</h3>
                  <p>
Fully equipped spaces for presentations, negotiations, and collaboration.                  </p>
                </div>
              </div>
            </div>

            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={helpdesk} alt="Helpdesk" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Professional Reception</h3>
                  <p>
Live front desk support to greet your clients and manage deliveries.                  </p>
                </div>
              </div>
            </div>

            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={prooms} alt="Prayer Rooms" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Private Lounge & Pantry</h3>
                  <p>
Comfortable areas designed for networking and professional interaction.                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row__sec__4">
            <div id="hdd" className="coL__sec4">
              <div className="row__sec__sub">
                <div  className="coL__sec4__sub">
                  <img src={dollor} alt="Competitive Prices" />
                </div>
                <div  className="coL__sec4__sub2">
                  <h3>Competitive Prices</h3>
                  <p>
                    Access our premium amenities at competitive prices, ensuring
                    exceptional value without compromising quality
                  </p>
                </div>
              </div>
            </div>

            <div className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={tea} alt="Tea and Coffee" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Prayer Rooms</h3>
                  <p>
Private dedicated spaces for reflection and spiritual practice.                  </p>
                </div>
              </div>
            </div>

            <div id="hdd" className="coL__sec4">
              <div className="row__sec__sub">
                <div className="coL__sec4__sub">
                  <img src={msrooms} alt="Meeting Rooms" />
                </div>
                <div className="coL__sec4__sub2">
                  <h3>Meeting Rooms</h3>
                  <p>
                    Book our well-equipped meeting rooms for a professional
                    setting suited to discussions, presentations, and
                    collaboration
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <br />
      <br />
      <br />

      <section style={{ background: "black", paddingTop: "50px", paddingBottom: "50px" }}>
        <div className="last_section" style={{ width: "80%", margin: "auto", textAlign: "center" }}>

          <div className="row__lst">
            <div className="lst__colm">
              <h2>Built for                 <span style={{ color: "#EEBD2B" }}>Growing Companies</span></h2>
              <br />
              <p>Whether you are launching a new venture or expanding your team, Xceed Office offers scalable  solutions that grow with your business. Upgrade from virtual office to private suite. Expand into  larger space as your team increases. Maintain flexibility without sacrificing image.</p>
            </div>
           <div className="lst__colm">
            <img src={framee} alt="" />
           </div>
          </div>
        
        

        </div>
      </section>

<br /><br /><br />
      <section>
        <div className="section__lst">
           <h2>Ready to Take the Next Step?</h2>

          <br />

          <p>
            Join the Xceed Office community today and elevate your work experience.
            <br />
            Discover how our workspace can help you achieve more.
          </p>

          <br />

          <button><img src={sv1}/> Book a Meeting &#10140;</button> &nbsp;
          <button style={{ color: "white", background: "black" }}>
            <span style={{ color: "white" }}><img src={sv2}/></span> Call Our Office
          </button>

          <br />

          <p className="lstt">
            Have questions? Call us at <a href="tel:+12817176060">(281) 717-6060</a>
          </p>
        </div>
        <br /><br />
      </section>
    </div>
  );
};

export default Home;